(function () {
  if (window.ToyPLP) return;
  window.ToyPLP = true;

  var CAR_SVG = '<svg viewBox="0 0 56 40"><rect x="12" y="4" width="30" height="16" rx="7" fill="#ff5a36"/><rect x="4" y="14" width="48" height="16" rx="8" fill="#ff5a36"/><rect x="16" y="8" width="10" height="8" rx="3" fill="#cfe9ff"/><rect x="29" y="8" width="10" height="8" rx="3" fill="#cfe9ff"/><circle cx="51" cy="20" r="2.5" fill="#ffc93c"/><circle cx="15" cy="31" r="6" fill="#1c1a3b"/><circle cx="15" cy="31" r="2.5" fill="#ffc93c"/><circle cx="41" cy="31" r="6" fill="#1c1a3b"/><circle cx="41" cy="31" r="2.5" fill="#ffc93c"/></svg>';

  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }

  var store = {
    get: function (k, d) { try { var v = JSON.parse(localStorage.getItem(k)); return v === null ? d : v; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* Wishlist */
  function paintWishlist(scope) {
    var list = store.get('toy-wishlist', []);
    (scope || document).querySelectorAll('[data-toy-wish]').forEach(function (b) {
      b.setAttribute('aria-pressed', list.indexOf(b.dataset.toyWish) > -1 ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-toy-wish]');
    if (!b) return;
    e.preventDefault();
    var h = b.dataset.toyWish;
    var list = store.get('toy-wishlist', []);
    var on = list.indexOf(h) === -1;
    list = on ? list.concat([h]) : list.filter(function (x) { return x !== h; });
    store.set('toy-wishlist', list);
    document.querySelectorAll('[data-toy-wish="' + h + '"]').forEach(function (x) { x.setAttribute('aria-pressed', String(on)); });
    b.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.35)' }, { transform: 'scale(1)' }], { duration: 380, easing: 'ease-out' });
    document.dispatchEvent(new CustomEvent('toy:wishlist', { detail: { handle: h, active: on, list: list } }));
  });

  /* Toast */
  var toastEl, toastTimer;
  function toast(msg, ok) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toy-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '';
    var icon = document.createElement('iconify-icon');
    icon.setAttribute('icon', ok ? 'mdi:check-circle' : 'mdi:alert-circle');
    var txt = document.createElement('span');
    txt.textContent = msg;
    toastEl.append(icon, txt);
    if (ok) {
      var a = document.createElement('a');
      a.href = routeRoot() + 'cart';
      a.textContent = 'View cart';
      toastEl.append(a);
    }
    toastEl.classList.toggle('is-error', !ok);
    requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3400);
  }

  /* Toy fly animation */
  function findCartIcon() {
    var sels = ['cart-icon', '#cart-icon-bubble', '.header-actions__cart-icon', '[data-cart-icon]', 'a[href$="/cart"]', 'a[href*="/cart"]'];
    for (var i = 0; i < sels.length; i++) {
      var els = document.querySelectorAll(sels[i]);
      for (var j = 0; j < els.length; j++) {
        if (els[j].closest('.toy-toast')) continue;
        var r = els[j].getBoundingClientRect();
        if (r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight) return els[j];
      }
    }
    return null;
  }

  function burst(x, y) {
    var colors = ['#ff5a36', '#ffc93c', '#2ec4b6', '#5b8cff', '#ff7eb6'];
    for (var i = 0; i < 14; i++) {
      (function (i) {
        var p = document.createElement('span');
        p.className = 'toy-confetti';
        p.style.background = colors[i % colors.length];
        p.style.left = x + 'px';
        p.style.top = y + 'px';
        document.body.appendChild(p);
        var a = (Math.PI * 2 * i) / 14;
        var d = 28 + Math.random() * 42;
        var anim = p.animate([
          { transform: 'translate(-50%, -50%) scale(1)', opacity: 1 },
          { transform: 'translate(' + (Math.cos(a) * d) + 'px, ' + (Math.sin(a) * d + 18) + 'px) rotate(' + (Math.random() * 360) + 'deg) scale(.4)', opacity: 0 }
        ], { duration: 650 + Math.random() * 350, easing: 'cubic-bezier(.2,.7,.3,1)' });
        anim.onfinish = function () { p.remove(); };
      })(i);
    }
  }

  function flyToCart(btn) {
    return new Promise(function (resolve) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { resolve(); return; }
      var target = findCartIcon();
      var s = btn.getBoundingClientRect();
      var t = target ? target.getBoundingClientRect() : { left: window.innerWidth - 70, top: 16, width: 40, height: 40 };
      var toy = document.createElement('div');
      toy.className = 'toy-fly';
      toy.innerHTML = CAR_SVG;
      document.body.appendChild(toy);

      var sx = s.left + s.width / 2 - 28, sy = s.top + s.height / 2 - 20;
      var ex = t.left + t.width / 2 - 28, ey = t.top + t.height / 2 - 20;
      var cx = (sx + ex) / 2, cy = Math.min(sy, ey) - 180;
      var flip = ex < sx ? -1 : 1;
      var frames = [], N = 28;
      for (var i = 0; i <= N; i++) {
        var k = i / N, m = 1 - k;
        var x = m * m * sx + 2 * m * k * cx + k * k * ex;
        var y = m * m * sy + 2 * m * k * cy + k * k * ey;
        var rot = Math.sin(k * Math.PI * 4) * 10;
        var sc = 1.15 - k * 0.65;
        frames.push({
          transform: 'translate(' + x + 'px, ' + y + 'px) rotate(' + rot + 'deg) scale(' + (sc * flip) + ', ' + sc + ')',
          opacity: k > 0.94 ? 0.2 : 1
        });
      }
      var anim = toy.animate(frames, { duration: 1000, easing: 'cubic-bezier(.45,.05,.35,1)' });
      anim.onfinish = function () {
        toy.remove();
        burst(ex + 28, ey + 20);
        if (target) {
          target.animate([
            { transform: 'scale(1)' },
            { transform: 'scale(1.3) rotate(-10deg)' },
            { transform: 'scale(.92) rotate(6deg)' },
            { transform: 'scale(1)' }
          ], { duration: 550, easing: 'ease-out' });
        }
        resolve();
      };
    });
  }

  function updateCartUI(cart, item, form) {
    // Horizon listens for "cart:update" and refreshes the cart bubble
    var ev = new Event('cart:update', { bubbles: true });
    ev.detail = {
      resource: cart,
      sourceId: form.id || 'toy-plp',
      data: { source: 'toy-plp', itemCount: cart.item_count, productId: item.product_id, sections: {} }
    };
    document.dispatchEvent(ev);
    document.dispatchEvent(new CustomEvent('toy:cart-added', { detail: { cart: cart, item: item } }));
    setCartCount(cart.item_count);
    var c = document.querySelector('.sz-header__cart');
    if (c) { c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump'); }
  }

  // header badge: update the number AND show it (the Shopz header hides it with data-zero when the cart was empty)
  function setCartCount(n) {
    document.querySelectorAll('[data-cart-count], .cart-bubble__text-count, .cart-count-bubble span[aria-hidden="true"]').forEach(function (el) {
      el.textContent = n;
      el.toggleAttribute('data-zero', !n);
      if (el.hidden && n) el.hidden = false;
    });
  }

  /* Add to cart */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('[data-toy-atc]') : null;
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (!btn || btn.disabled || btn.classList.contains('is-busy')) return;
    btn.classList.add('is-busy');
    var started = Date.now();
    var id = Number(form.querySelector('[name="id"]').value);
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = Number(qtyInput ? qtyInput.value : 1) || 1;
    var added;

    fetch(routeRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty })
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok || r.data.status) throw new Error(r.data.description || r.data.message || 'Could not add to cart');
        added = r.data;
        return fetch(routeRoot() + 'cart.js').then(function (res) { return res.json(); });
      })
      .then(function (cart) {
        var wait = Math.max(0, 800 - (Date.now() - started));
        return new Promise(function (ok) { setTimeout(ok, wait); }).then(function () {
          btn.classList.remove('is-busy');
          btn.classList.add('is-added');
          return flyToCart(btn);
        }).then(function () {
          updateCartUI(cart, added, form);
          toast((added.product_title || added.title) + ' added to cart!', true);
          setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
        });
      })
      .catch(function (err) {
        btn.classList.remove('is-busy');
        toast(err.message || 'Something went wrong', false);
        btn.animate([
          { transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' },
          { transform: 'translateX(-4px)' }, { transform: 'translateX(0)' }
        ], { duration: 400 });
      });
  });

  /* Collection element: filters, sort, pagination, load more */
  class ToyCollection extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.sectionId = this.dataset.sectionId;
      this.view = store.get('toy-plp-view', 'grid');
      this.closedGroups = new Set();
      this.expandedGroups = new Set();
      this._req = 0;
      this.submitSoon = debounce(this.submit.bind(this), 450);

      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('input', this.onInput.bind(this));
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('submit', (e) => {
        if (e.target.matches('[data-toy-filter-form]')) {
          e.preventDefault();
          this.toggleDrawer(false);
          this.submit();
        }
      });
      this.addEventListener('toggle', (e) => {
        var d = e.target;
        if (!d.dataset || !d.dataset.group) return;
        if (d.open) this.closedGroups.delete(d.dataset.group);
        else this.closedGroups.add(d.dataset.group);
      }, true);
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.toggleDrawer(false); });
      this._pop = () => this.render(location.href, false);
      window.addEventListener('popstate', this._pop);
      this.applyUI();
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this._pop);
      document.documentElement.classList.remove('toy-lock');
    }

    onChange(e) {
      var t = e.target;
      if (t.matches('[data-toy-sort]')) { this.submit(); return; }
      if (!t.closest('[data-toy-filter-form]')) return;
      if (t.matches('[data-range-min], [data-range-max]')) { this.submitSoon(); return; }
      if (t.matches('[data-price-min], [data-price-max]')) {
        this.syncPrice(t.closest('[data-toy-price]'), 'input');
        this.submitSoon();
        return;
      }
      if (t.type === 'checkbox') this.submitSoon();
    }

    onInput(e) {
      var t = e.target;
      if (t.matches('[data-range-min], [data-range-max]')) this.syncPrice(t.closest('[data-toy-price]'), 'range', t);
    }

    onClick(e) {
      var link = e.target.closest('a[data-toy-link]');
      if (link) {
        e.preventDefault();
        this.render(link.href, true, !!link.closest('[data-toy-pagination]'));
        return;
      }
      var more = e.target.closest('[data-toy-more]');
      if (more) {
        var g = more.closest('[data-group]');
        var on = !g.classList.contains('is-expanded');
        g.classList.toggle('is-expanded', on);
        if (on) this.expandedGroups.add(g.dataset.group); else this.expandedGroups.delete(g.dataset.group);
        more.textContent = on ? more.dataset.less : more.dataset.more;
        return;
      }
      var view = e.target.closest('[data-toy-view]');
      if (view) {
        this.view = view.dataset.toyView;
        store.set('toy-plp-view', this.view);
        this.applyUI();
        return;
      }
      var lm = e.target.closest('[data-toy-loadmore]');
      if (lm) { this.loadMore(lm); return; }
      if (e.target.closest('[data-toy-drawer-open]')) { this.toggleDrawer(true); return; }
      if (e.target.closest('[data-toy-drawer-close]')) this.toggleDrawer(false);
    }

    toggleDrawer(on) {
      this.classList.toggle('is-drawer-open', on);
      document.documentElement.classList.toggle('toy-lock', on);
    }

    syncPrice(wrap, from, source) {
      if (!wrap) return;
      var max = Number(wrap.dataset.max) || 0;
      var rMin = wrap.querySelector('[data-range-min]'), rMax = wrap.querySelector('[data-range-max]');
      var iMin = wrap.querySelector('[data-price-min]'), iMax = wrap.querySelector('[data-price-max]');
      if (!rMin || !rMax) return;
      var lo, hi;
      if (from === 'range') {
        lo = Number(rMin.value);
        hi = Number(rMax.value);
        if (lo > hi) {
          if (source === rMin) { lo = hi; rMin.value = lo; } else { hi = lo; rMax.value = hi; }
        }
        iMin.value = lo > 0 ? lo : '';
        iMax.value = hi < max ? hi : '';
      } else if (from === 'input') {
        lo = iMin.value === '' ? 0 : Math.max(0, Math.min(Number(iMin.value), max));
        hi = iMax.value === '' ? max : Math.max(lo, Math.min(Number(iMax.value), max));
        rMin.value = lo;
        rMax.value = hi;
      } else {
        lo = Number(rMin.value);
        hi = Number(rMax.value);
      }
      var fill = wrap.querySelector('.toy-range__fill');
      if (fill && max) {
        fill.style.left = (lo / max) * 100 + '%';
        fill.style.right = (100 - (hi / max) * 100) + '%';
      }
    }

    buildUrl() {
      var params = new URLSearchParams();
      var form = this.querySelector('[data-toy-filter-form]');
      if (form) {
        new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
      }
      var sort = this.querySelector('[data-toy-sort]');
      if (sort) params.set('sort_by', sort.value);
      var qs = params.toString();
      return this.dataset.collectionUrl + (qs ? '?' + qs : '');
    }

    submit() { this.render(this.buildUrl(), true); }

    async render(url, push, scroll) {
      this._req += 1;
      var id = this._req;
      this.classList.add('is-loading');
      try {
        var u = new URL(url, location.origin);
        u.searchParams.set('section_id', this.sectionId);
        var html = await fetch(u.toString()).then(function (r) { return r.text(); });
        if (id !== this._req) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-toy-root]');
        var current = this.querySelector('[data-toy-root]');
        if (fresh && current) current.replaceWith(fresh);
        if (push) {
          var clean = new URL(url, location.origin);
          clean.searchParams.delete('section_id');
          history.pushState({ toy: true }, '', clean.pathname + clean.search);
        }
        this.applyUI();
        if (scroll) this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        document.dispatchEvent(new CustomEvent('toy:collection-updated', { detail: { url: url } }));
      } catch (err) {
        window.location.href = url;
      } finally {
        if (id === this._req) this.classList.remove('is-loading');
      }
    }

    async loadMore(btn) {
      if (btn.classList.contains('is-busy')) return;
      btn.classList.add('is-busy');
      try {
        var u = new URL(btn.dataset.nextUrl, location.origin);
        u.searchParams.set('section_id', this.sectionId);
        var html = await fetch(u.toString()).then(function (r) { return r.text(); });
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = this.querySelector('[data-toy-grid]');
        var cards = doc.querySelectorAll('[data-toy-grid] > *');
        cards.forEach(function (c, i) {
          c.classList.add('toy-card--enter');
          c.style.animationDelay = (i * 45) + 'ms';
          grid.appendChild(c);
        });
        ['[data-toy-pagination]', '[data-toy-loadmore-wrap]'].forEach((sel) => {
          var a = this.querySelector(sel), b = doc.querySelector(sel);
          if (a) { if (b) a.replaceWith(b); else a.remove(); }
        });
        var end = this.querySelector('[data-toy-count-end]'), newEnd = doc.querySelector('[data-toy-count-end]');
        if (end && newEnd) end.textContent = newEnd.textContent;
        paintWishlist(this);
      } catch (err) {
        window.location.href = btn.dataset.nextUrl;
      } finally {
        btn.classList.remove('is-busy');
      }
    }

    applyUI() {
      var grid = this.querySelector('[data-toy-grid]');
      if (grid) grid.classList.toggle('toy-grid--list', this.view === 'list');
      this.querySelectorAll('[data-toy-view]').forEach((b) => b.classList.toggle('is-active', b.dataset.toyView === this.view));
      this.querySelectorAll('details[data-group]').forEach((d) => {
        if (this.closedGroups.has(d.dataset.group)) d.open = false;
        if (this.expandedGroups.has(d.dataset.group)) {
          d.classList.add('is-expanded');
          var m = d.querySelector('[data-toy-more]');
          if (m) m.textContent = m.dataset.less;
        }
      });
      this.querySelectorAll('[data-toy-price]').forEach((w) => this.syncPrice(w, 'init'));
      paintWishlist(this);
    }
  }

  if (!customElements.get('toy-collection')) customElements.define('toy-collection', ToyCollection);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { paintWishlist(); });
  else paintWishlist();
})();